<template>
    <div id='captura'>
    <br><br>
    <div class="column is-half is-offset-one-quarter " align="center">

        <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i>Regresar</a>

        <form v-on:submit.prevent= 'guardarPersona'>

            <div class="columns" >  
            <div class="column " align="left">
                <br>                  
                <div class='field'>
                    <div class="label">Email</div>
                    <div class='control'>
                        <input class='input' type='email' placeholder='Email' required v-model='persona.email'>
                    </div>
                </div>
                <div class='field'>
                    <div class="label">Nombre completo</div>
                    <div class='control'>
                        <input class='input' type='text' placeholder='Nombre' required v-model='persona.nombre'>
                    </div>
                </div>
                <div class='field'>
                    <div class="label">Su nueva clave</div>
                    <div class='control'>
                        <input class='input' type='password' placeholder='Mi nueva clave' required v-model='persona.suClave'>
                    </div>
                </div>
            </div>

            </div>
            <br>
            <input type="submit" class="button is-primary" name="agregandoPersona" value="Entrar">
            <br>
            <br>

        </form>
    </div>
  </div>
</template>

<script>
    import axios from 'axios';
    export default{
            name:'agregar-persona',
            props: ['vectoruno'],  
            mounted(){
            },
            data(){
                return {
                    persona:{
                        email:'',
                        suClave:'',
                        nombre:''
                    }
                };
            },
            methods:{
                guardarPersona(){
                    var router = this.$router;
                    axios.post('https://www.rentas-ventas.com/primeraVez.php?elmail1='+this.persona.email)
                            .then((respue) => {
                                var yaExiste = respue.data.includes("yaexiste*");
                                if(yaExiste){
                                    alert("Ya existe un usuario con este mail");
                                    router.push('/');
                                }else{
                                    axios.post('https://www.rentas-ventas.com/agregaPersona.php?mai51='+this.persona.email+'&nom51='+this.persona.nombre+'&cla51='+this.persona.suClave)
                                            .then((respue) => {
                                                alert("\n\nAhora entra nuevamente y en \n'Mis anuncios' dalos de alta\n\nMuchas Gracias");
                                                router.push('/');
                                        })
                                        .catch((error) =>{
                                            alert("\n\nError en el servidor");
                                            console.log(error);
                                            router.push('/');
                                        });
                                }
                            })
                                .catch((error) =>{
                                    alert("Servidor o wifi no disponible");
                                    console.log("hubo error " + error);
                                    router.push('/');
                            });                      
                },
                regresar(){
                    this.$emit('regresar'); 
                    this.$router.push({ name: '/'});
                }
            }
    }
</script>


// WEBPACK FOOTER //
// src/Nuevo.vue